import { Component, HostBinding } from '@angular/core';

import { DsLoadingSpinner } from '@frontend/ui/loading-spinner';

@Component({
    selector: 'ms-component-loader',
    imports: [DsLoadingSpinner],
    template: '<ds-loading-spinner />',
})
export class ComponentLoaderComponent {
    @HostBinding('class') className = 'component-loader';
}
